import { create } from "zustand";

interface MapSlice {
    map: google.maps.Map | undefined;
    setMap: (value: google.maps.Map | undefined) => void;
    blurSearchInputField: boolean;
    setBlurSearchInputField: (newBlurSearchInputField: boolean) => void;
}
export const useMapSearchFieldStore = create<MapSlice>()((set) => ({
    map: undefined,
    setMap: (newValue) =>
        set(() => ({
            map: newValue,
        })),
    blurSearchInputField: false,
    setBlurSearchInputField: (newValue) =>
        set(() => ({
            blurSearchInputField: newValue,
        })),
}));
